module.exports = __webpack_public_path__ + "static/img/14000589.f20404e5.png";